// Utils
import { getColor } from "../../../utils/getColor";

interface CustomStyleProps {
	size?: "small" | "standard";
	leftIcon?: any;
	isClearable?: boolean;
	showWarning?: boolean;
	maxHeight?: number;
}

const Config = {
	customStyles: (props: CustomStyleProps) => {
		const { size = "standard", leftIcon, isClearable, showWarning, maxHeight } = props;

		const height = size === "standard" ? 32 : 24;
		const lineHeight = size === "standard" ? "20px" : "16px";
		const fontSize = size === "standard" ? "14px" : "12px";

		return {
			placeholder: (base) => ({
				...base,
				textAlign: "left",
			}),
			control: (base, { isDisabled }) => ({
				...base,
				//background: getColor("neutral", 0),
				borderColor: showWarning ? getColor("red", 6) : getColor("neutral", 3), // hard coded in order to match other inputs
				minHeight: height,
				height: height,
				boxShadow: null,
				borderRadius: "4px",
				boxSizing: "border-box",
				lineHeight: lineHeight,
				"&:hover": isDisabled
					? { borderColor: `1px solid ${getColor("neutral", 2)}` }
					: { borderColor: showWarning ? getColor("red", 6) : getColor("neutral", 6) }, // border style on hover
				backgroundColor: getColor("neutral", 0),
				color: isDisabled ? getColor("neutral", 4) : undefined,
				border: isDisabled ? `1px solid ${getColor("neutral", 2)}` : undefined,
				pointerEvents: isDisabled && "auto",
				cursor: isDisabled ? "not-allowed" : isClearable ? "text" : "pointer",
			}),

			indicatorSeparator: () => ({
				display: "none",
			}),

			indicatorsContainer: (base) => ({
				...base,
				fontSize: fontSize,
				height: height - 2,
				":hover": {
					cursor: "pointer",
				},
				// check this one
				marginRight: "4px;",
				display: isClearable ? "none" : "flex",
			}),

			dropdownIndicator: (base, { isDisabled }) => ({
				...base,
				color: getColor("neutral", 5),
				height: "100%",
				display: "flex",
				justifyContent: "center",
				flexDirection: "column",
				padding: 4,
				cursor: isDisabled ? "not-allowed" : "pointer",
			}),

			clearIndicator: (base) => ({
				...base,
				color: getColor("neutral", 5),
				padding: "4px",
			}),

			valueContainer: (base) => ({
				...base,
				height: height - 2, // - 2px border
				padding: "0 8px",
				paddingLeft: leftIcon ? 28 : 8,
				paddingRight: isClearable ? 24 : 8,
				fontSize: fontSize,
			}),

			menu: (base) => ({
				...base,
				borderRadius: "4px",
				border: `1px solid ${getColor("neutral", 3)}`,
				boxShadow: null,
				overflow: "hidden",
				zIndex: 2,
			}),

			menuList: (base) => ({
				...base,
				padding: "0px",
				maxHeight: maxHeight || "256px",
			}),

			groupHeading: (base) => {
				return {
					...base,
					paddingLeft: "8px",
					textTransform: "none",
					marginBottom: "8px",
				};
			},

			group: (base) => ({
				...base,
				paddingBottom: "0px",
			}),

			option: (base, options) => {
				const { isFocused } = options;
				const isGrouped = options.options[0].options !== undefined;

				return {
					...base,
					display: "flex",
					alignItems: "center",
					backgroundColor: isFocused ? getColor("neutral", 2) : getColor("neutral", 0),
					color: isFocused ? getColor("neutral", 9) : getColor("neutral", 5),
					cursor: "pointer",
					padding: size === "standard" ? "8px 0 8px 8px" : "4px 8px 4px 8px",
					fontSize: size === "standard" ? "14px" : "12px",
					lineHeight: size === "standard" ? "16px" : "16px",
					paddingLeft: isGrouped ? "16px" : "8px",
					":active": {
						...base[":active"],
						backgroundColor: getColor("neutral", 1),
					},
					whiteSpace: size ? "nowrap" : undefined,
					overflow: size ? "hidden" : undefined,
					textOverflow: size ? "ellipsis" : undefined,
				};
			},

			multiValue: (base) => ({
				...base,
				backgroundColor: getColor("neutral", 1),
				height: "20px",
				display: "flex",
				alignItems: "center",
			}),

			multiValueRemove: (base) => ({
				...base,
				height: "20px",
				":hover": {
					backgroundColor: getColor("neutral", 2),
					cursor: "pointer",
				},
			}),

			singleValue: (base) => ({
				...base,
				margin: "0px",
				fontFamily: "Source Sans Pro",
			}),

			input: (base) => ({
				...base,
				padding: "0px",
				input: {
					gridArea: "1 / 2 / 4 / 4 !important",
				},
			}),
		};
	},
};

export default Config;
